import Checkbox from '@ben/orion/checkbox';
import Select from '@ben/orion/deprecated-select';
import Input from '@ben/orion/input';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { fieldCannotBeBlankErrorMessage } from '../../../shared/constants';

const dateFormatOptions = [
  { key: 'yyyyMMdd_SLASHES', label: 'yyyy/MM/dd' },
  { key: 'yyyyMMdd_DASHES', label: 'yyyy-MM-dd' },
  { key: 'MMddyyyy_SLASHES', label: 'MM/dd/yyyy' },
  { key: 'MMddyyyy_DASHES', label: 'MM-dd-yyyy' },
  { key: 'ddMMyyyy_SLASHES', label: 'dd/MM/yyyy' },
  { key: 'ddMMyyyy_DASHES', label: 'dd-MM-yyyy' },
  { key: 'ddMMMyyyy_SPACES', label: 'dd MMM yyyy' },
];

interface IModularDateInputProps {
  componentControllerName: string;
}

const ModularDateInput = ({
  componentControllerName,
}: IModularDateInputProps) => {
  const { control } = useFormContext();

  const dateFormat = useWatch({
    name: `${componentControllerName}.dateFormat`,
    exact: true,
  }) as string;

  const dateFormatValue = dateFormat
    ? dateFormatOptions.find((opt) => opt.key === dateFormat)?.label
    : '';

  return (
    <Wrapper>
      <Controller
        control={control}
        name={`${componentControllerName}.dateFormat`}
        render={({ field, fieldState }) => (
          <Select
            {...field}
            name="Date format"
            options={dateFormatOptions}
            defaultValue={dateFormatValue}
            hasError={!!fieldState.error}
            errorMessage={fieldState.error?.message}
            width="230px"
          />
        )}
        rules={{ required: fieldCannotBeBlankErrorMessage }}
      />
      <Controller
        control={control}
        name={`${componentControllerName}.default`}
        render={({ field }) => (
          <Input {...field} name="Default value (optional)" width="230px" />
        )}
      />
      <Controller
        control={control}
        name={`${componentControllerName}.allowFutureDates`}
        render={({ field }) => (
          <StyledCheckbox {...field} label="Allow future dates" />
        )}
      />
    </Wrapper>
  );
};

export default ModularDateInput;

const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(2)};
  `}
`;

const StyledCheckbox = styled(Checkbox)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(4)};
  `}
`;
